import { createListStore } from "./list";
import { FilesService } from "@/services/files";

export const useFilesStore = createListStore("files", FilesService);
